import { render } from "./HelpModal.vue?vue&type=template&id=2dce6f8c&scoped=true"
import script from "./HelpModal.vue?vue&type=script&lang=js"
export * from "./HelpModal.vue?vue&type=script&lang=js"

import "@/assets/css/HelpModal.scss?vue&type=style&index=0&id=2dce6f8c&lang=scss&scoped=true"

import exportComponent from "/builds/legand/anomyma/commerce-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dce6f8c"]])

export default __exports__